import "../scss/style.scss";
import "./home.js";
import "./column.js";
import 'lity';

jQuery(function ($) {

	// sp 100vh adjustment
	$(function () {
		'use strict';
		var $window = $(window)
		var ww = $window.innerWidth();
		if (ww <= 768) {
			$(document).ready(function () {
					var hSize = $window.height();
					$('.js-mv').height(hSize);
			});
			$window.resize(function () {
					var hSize = $window.height();
					$('.js-mv').height(hSize);
			});
		}
	});

	$(function(){
		var pagetop = $('.js-banner');
		pagetop.hide();
		$(window).scroll(function () {
			 if ($(this).scrollTop() > 100) {
						pagetop.fadeIn();
			 } else {
						pagetop.fadeOut();
			 }
		});
	});

	// smooth scroll
	$(function() {
		$('a[href^="#"]').not('.member-list-item, .value-list-item, .sample-list-item').click(function(){
			var speed = 1000;
			var href= $(this).attr("href");
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top;
			$("html, body").animate({scrollTop:position}, speed, "swing");
			return false;
		});
	});

	// SP nav
	$(document).ready(function () {
		$('.js-nav-bt').on('click', function () {
			if ($('.js-nav-header, .js-nav-content').hasClass('close')) {
				$(".js-nav-header, .js-nav-content").removeClass('close');
				$(this).removeClass('close');
			} else {
				$(".js-nav-header, .js-nav-content").addClass('close');
				$(this).addClass('close');
			}
		});
		$('.navContent-list01-item a, .navContent-list02-item a').on('click', function () {
			$(".js-nav-bt.close, .js-nav-header.close, .js-nav-content.close").removeClass('close');
		});
	});

	// fixed bt
	$(function() {
		// 	var this_element;
		// jQuery(window).on('load',function(){
		// 	this_element = jQuery('.js-outPosition').offset().top + jQuery('.js-outPosition').outerHeight();
		// });

		// jQuery(window).scroll(function () {
		// 	if(jQuery(window).scrollTop() + jQuery(window).height() > this_element){
		// 		jQuery('.js-fixedOut').fadeOut();
		// 	} else {
		// 		jQuery('.js-fixedOut').fadeIn();
		// 	}
		// });
	});

	// scroll animation
	$(document).on('load scroll', function () {
		$('.js-fadeUp').each(function () {
			var targetElement = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
				if (scroll > targetElement - windowHeight + 100){
					$(this).addClass('scrollin');
			}
			// else {
			// 	$(this).removeClass('scrollin');
			// }
		});
	});

	// pullDown
	$('.js-pullDown').on('click', function (event) {
		event.preventDefault();
		$(this).toggleClass('close');
		$(this).next().slideToggle();
	});

});
